import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "revenue-content"
};
const __default__ = {
  name: 'paidEventBillboardIndex'
};
import RevenueHeader from '@/views/paidEventBillboard/components/RevenueHeader.vue';
import EchartsContent from '@/views/paidEventBillboard/components/EchartsContent.vue';
import TableContent from '@/views/paidEventBillboard/components/TableContent.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const echartRef = ref(null);
    const tableRef = ref(null);
    const loading = ref(false);
    const searchData = (searchObj = {}) => {
      var _tableRef$value, _echartRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(searchObj);
      (_echartRef$value = echartRef.value) === null || _echartRef$value === void 0 || _echartRef$value.searchData(searchObj);
    };
    const changeLoading = val => {
      loading.value = val;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RevenueHeader, {
        onReturnSearch: searchData,
        loading: loading.value
      }, null, 8, ["loading"]), _createVNode(EchartsContent, {
        ref_key: "echartRef",
        ref: echartRef
      }, null, 512), _createVNode(TableContent, {
        ref_key: "tableRef",
        ref: tableRef,
        onChangeLoading: changeLoading
      }, null, 512)]);
    };
  }
});